import { HTTP_API_V2 } from '../../http-common'

// The batch endpoint prepends the latest current-day entry from the per-hour
// (24h) table on top of the completed daily rows. When that entry's age already
// exists as a completed daily aggregation, both rows share the same age and the
// charts render a duplicate day. This keeps a single row per age, preferring the
// daily aggregation (full end-of-day values) over the per-hour snapshot: the
// per-hour row always comes first in the payload, so writing rows into a Map
// keyed by age lets the later daily row win, while a genuinely new current day
// (no daily row yet) is preserved.
function dedupeWeighingsByAge (rows) {
  if (!Array.isArray(rows)) {
    return []
  }
  const byAge = new Map()
  rows.forEach((row, index) => {
    const age = Number(row && row.age)
    const key = isNaN(age) ? `no-age-${index}` : age
    byAge.set(key, row)
  })
  return Array.from(byAge.values())
}

export default {
  state: {
    loadedWeightAnalysis: []
  },
  getters: {
    loadedWeightAnalysis (state) {
      return state.loadedWeightAnalysis
    }
  },
  mutations: {
    setLoadedWeightAnalysis (state, payload) {
      state.loadedWeightAnalysis = payload
    },
    clearloadedWeightAnalysis (state) {
      state.loadedWeightAnalysis = []
    }
  },
  actions: {
    fetchWeightAnalysisByDeviceIdAndInitialDateAndFinalDate ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedWeightAnalysis', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('weight-analysis', {
          params: {
            mac: payload.mac || null,
            initial_date: payload.initial_date || null,
            initial_hour: payload.initial_hour || null,
            final_date: payload.final_date || null,
            final_hour: payload.final_hour || null
          }
        })
        .then(result => {
          commit('setLoadedWeightAnalysis', result.data)
          resolve(result.data)
        })
        .catch(err => {
          commit('setError', err)
          reject(err)
        })
        .finally(() => {
          commit('setLoading', false)
        })
      })
    },
    clearloadedWeightAnalysis ({ commit }) {
      commit('clearloadedWeightAnalysis')
    },
    // Loads a batch's weighings from the batch endpoint, which appends the
    // latest current-day entry from the per-hour (24h) telemetry table on top
    // of the completed daily rows. `date` is the lower bound (the batch's
    // initial date) so the full flock history is returned.
    fetchWeightAnalysisByBatchIdAndDate ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedWeightAnalysis', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get(`batches/${payload.batchId}/weight_analysis`, {
          params: {
            date: payload.date || null
          }
        })
        .then(result => {
          const rows = dedupeWeighingsByAge(result.data)
          commit('setLoadedWeightAnalysis', rows)
          resolve(rows)
        })
        .catch(err => {
          commit('setError', err)
          reject(err)
        })
        .finally(() => {
          commit('setLoading', false)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/weight_analysis/index.js